import {setIsDevicesInitialized} from '../../state/slice/session';
import {dispatch} from '../../state/store';
import damService from '../dam/damService';
import log from '../logger/log';
import notificationService from '../notificationService';

const initUserDevices = async () => {
    try {
        log.info('deviceService: Start initialization of user devices');

        await damService.setUserDevices();

        log.info('deviceService: End initialization of user devices. Success');
    } catch (e) {
        log.info('deviceService: End initialization of user devices. Failed');

        notificationService.showRequestError();
    } finally {
        dispatch(setIsDevicesInitialized(true));
    }
};

export default {
    initUserDevices,
};
